import classNames from 'classnames';
import * as React from 'react';
import { Dictionary } from 'ts-essentials';

import { Csat } from '../types';

import { CsatToggle } from './components/CsatToggle';
import styles from './index.module.scss';

export interface OwnProps {
  // If you want to support a new channel just remove it from the excluded ones below
  channel: Csat.SupportedChannels;
  isActive: boolean;
  disabled?: boolean;
}

export interface DispatchProps {
  onChange: (change: Csat.CsatStatusChange) => void;
}

type Props = OwnProps & DispatchProps;

const headersDictionary: Dictionary<string, Csat.SupportedChannels> = {
  email: 'CSAT for Email & Contact Form',
  widgetchat: 'CSAT for Chat',
  messenger: 'CSAT for Messenger',
  pstnphone: 'CSAT for Phone',
};

const descriptionsDictionary: Dictionary<string, Csat.SupportedChannels> = {
  email:
    'Turn this on to start sending a Customer Satisfaction email whenever an Email or Contact Form conversation is closed. In the settings below you can specify which contact points should be enabled and customize your surveys.',
  widgetchat:
    'Turn this on to show a Customer Satisfaction survey whenever a chat conversation is closed. In the settings below you can customize your surveys.',
  messenger:
    'Turn this on to show a Customer Satisfaction survey whenever a chat conversation is closed in Messenger widget. In the settings below you can customize your surveys.',
  pstnphone:
    'Turn this on to show a Customer Satisfaction survey whenever a call conversation is closed in Dixa. In the settings below you can customize your surveys.',
};

export const GlobalCsatSwitch: React.FunctionComponent<Props> = (props) => {
  const humanReadableHeader = headersDictionary[props.channel];
  const humanReadableDescription = descriptionsDictionary[props.channel];

  return (
    <div
      className={classNames(styles.root, {
        [styles.rootDisabled]: props.disabled,
      })}
    >
      <div className={styles.description}>
        <h2 className={styles.header}>{humanReadableHeader}</h2>
        <div className={styles.subHeader}>{humanReadableDescription}</div>
      </div>
      <CsatToggle
        id={`global-switch-${props.channel}`}
        channel={props.channel}
        isActive={props.isActive}
        onChange={props.onChange}
      />
    </div>
  );
};
